<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 70px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('cp_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('cp_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../assets/imgs/companyprofile.png" class="pman" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-company-sidebar v-if="profileLoaded" :selectedItem="selectedItem"></app-company-sidebar>
          </div>
          <div class="col-md-9">
            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('company_user_page')}}</span>
            </div>

            <div class="row pview align-items-center">
              <div class="col-md-3 text-center">
                  <video v-if="company_user_video"   height="150" width="150" controls autoplay loop>
                    <source :src="company_user_video">
                  </video>

                  <img v-if="company_user_image" class="avatar" :src="company_user_image" />
              </div>
              <div class="col-md-8 offset-md-1">
                <div class="row">
                  <div class="col-md-6">
                    <label class="pgraytxt mplus2p-m spacing1-2 noiseblack ">{{$t('r_lastname')}}:</label>
                    <p class="mplus2p-m spacing1-2 noiseblack">{{company_user_lastname}}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="pgraytxt mplus2p-m spacing1-2 noiseblack ">{{$t('r_firstname')}}:</label>
                    <p class="mplus2p-m spacing1-2 noiseblack">{{company_user_firstname}}</p>
                  </div>
                </div>
              </div>

              <template v-if="company_user_nickname">
                <div class="col-md-12" style="height: 38px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('r_nickname')}}</p>
                </div>
                <div class="col-md-9">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{company_user_nickname}}</p>
                </div>
              </template>

              <template v-if="company_user_email">
                <div class="col-md-12" style="height: 38px;"></div>
                <div class="col-md-3">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('r_email')}}</p>
                </div>
                <div class="col-md-9">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{company_user_email}}</p>
                </div>
              </template>

              <div class="col-md-12" style="height: 38px;"></div>
              <div class="col-md-12 pv_btnpanel">
                <router-link :to="{ name: 'companyUserProfileEdit', params: {cid: this.$route.params.cid, uid: this.$route.params.uid} }">
                  <button class="btn bluebtn updatebtn">{{$t('ep_button')}}</button>
                </router-link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import companySidebar from "./company_sidebar";
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default {
  data() {
    return {
      selectedItem: 3,
      loading: false,
      userId: "",
      companyId: "",
      company_user_desc: "",
      company_user_firstname: "",
      company_user_lastname: "",
      company_user_nickname: "",
      company_user_id: "",
      company_user_bday: "",
      company_user_sex: "",
      company_user_location: "",
      company_user_howToWorkNow: "",
      company_user_howToWOrk: "",
      company_user_decs_emp_con: "",
      company_user_desc_emp_from: "",
      company_user_policy: "",
      company_user_email: "",
      company_user_image: "",
      company_user_video:"",
      company_user_experience: "",

      profileLoaded: false,

      model: {},
      lan: ""
    };
  },
  components: {
    appCompanySidebar: companySidebar
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }

    var data = JSON.parse(localStorage.getItem("user"));
    var uId = data.user_token;
    var cId = data.company.company_token;
    var trial_expired = data.company.trial_expired

    if(trial_expired){
      var vm = this;
      const swalWithBootstrapButtons = Swal.mixin({
          confirmButtonClass: 'btn btn-danger inquiry',
          cancelButtonClass: 'btn trial',
          buttonsStyling: false,
        })

        swalWithBootstrapButtons({
          title: vm.$t("trial_period"),
          text:  vm.$t("trial_period_desc"),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t("inquiry"),
          cancelButtonText: vm.$t("logout"),
          reverseButtons: false,
          allowOutsideClick: false
        }).then((result) => {
          if (result.value) {
            vm.$store.dispatch("logout");
            vm.$router.push('/global/contact-inqury')
          } else if (
            // Read more about handling dismissals
            result.dismiss === Swal.DismissReason.cancel
          ) {
            vm.$store.dispatch("logout");
          }
        })
    }
    if (uId != this.$route.params.uid || cId != this.$route.params.cid) {
      this.$router.push("/global/PageNotFound");
    }
    this.model.total = 100;
    this.model.technical = 6;
    this.model.management = 26;
    this.model.business = 70;

    this.userId = data.id;
    this.companyId = data.company.id;
    this.engineerProfile(this.userId);
  },
  mounted() {
    this.doCenter();
  },
  computed: {
    onResize(event) {
      this.doCenter();
    }
  },
  methods: {
    engineerProfile(id) {
      this.loading = true;
      axios
        .get("/user/" + id + "?token=" + localStorage.getItem("token"), {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {

            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
             if (res.data.errors) {
              for (var i = 0; i < res.data.errors.length; i++) {
                if (res.data.errors[i].message) {
                  this.$toaster.error(res.data.errors[i].message);
                  return  this.$store.dispatch("logout");
                }
              }
              this.loading = flase;
          }
          }
          else{
              this.image = res.data.user.image;
              this.company_user_desc = res.data.user.skill;
              this.company_user_nickname = res.data.user.nickname;
              this.company_user_firstname = res.data.user.first_name;
              this.company_user_lastname = res.data.user.last_name;
              this.company_user_id = res.data.user.id;
              this.company_user_email = res.data.user.email;
              if (res.data.user.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
                this.company_user_video = res.data.user.image
              }else{
                this.company_user_image = res.data.user.image;
              }
              this.company_user_bday = res.data.user.birthdate;
              this.company_user_sex = res.data.user.gender;
              this.company_user_location = res.data.user.location;
              this.company_user_howToWorkNow = res.data.user.how_to_work_now;
              this.company_user_howToWOrk = res.data.user.wanted_job;
              this.company_user_decs_emp_con = res.data.user.employment_condition;
              this.company_user_desc_emp_from = res.data.user.employment_form;
              this.company_user_policy = res.data.user.policy;
              this.company_user_experience = res.data.user.experience;
              this.company_user_wanted_job = res.data.user.wanted_job;
              var user = JSON.parse(localStorage.user)
              user.test_user = res.data.user.test_user
              localStorage.setItem("user",JSON.stringify(user));
              this.profileLoaded = true;
              this.loading = false;
          }
        })
        .catch(error => console.log(error));
    },
    doCenter() {
      let txtheight, txtwidth;
      if ($(window).width() <= 975 && $(window).width() >= 751) {
        $("#total").css("font-size", "1rem");
        $("#technical").css("font-size", "1rem");
        $("#management").css("font-size", "1rem");
        $("#business").css("font-size", "1rem");
        txtwidth = [10.44, 20.88, 31.3];
        txtheight = 40;
      } else {
        $("#total").css("font-size", "1.5rem");
        $("#technical").css("font-size", "1.5rem");
        $("#management").css("font-size", "1.5rem");
        $("#business").css("font-size", "1.5rem");
        txtwidth = [15.66, 31.3, 46.95];
        txtheight = 28;
      }

      const ttrighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
      const ttrightright =
        ($(".chartboxes").width() -
          txtwidth[this.model.total.toString().length - 1]) /
        2;
      $("#total").css("margin-top", ttrighttop.toString() + "px");
      $("#total").css("margin-left", ttrightright.toString() + "px");

      const thrighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
      const thrightright =
        ($(".chartboxes").width() -
          txtwidth[this.model.technical.toString().length - 1]) /
        2;
      $("#technical").css("margin-top", thrighttop.toString() + "px");
      $("#technical").css("margin-left", thrightright.toString() + "px");
      const mgrighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
      const mgrightright =
        ($(".chartboxes").width() -
          txtwidth[this.model.management.toString().length - 1]) /
        2;
      $("#management").css("margin-top", mgrighttop.toString() + "px");
      $("#management").css("margin-left", mgrightright.toString() + "px");

      const birighttop = ($(".chartboxes").height() - txtheight) / 2 + 4;
      const birightright =
        ($(".chartboxes").width() -
          txtwidth[this.model.business.toString().length - 1]) /
        2;
      $("#business").css("margin-top", birighttop.toString() + "px");
      $("#business").css("margin-left", birightright.toString() + "px");
    }
  }
};
</script>

<style scoped>
.pman {
  width: auto;
  margin-top: 70px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
  border-radius: 100%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  /*right: 46%;
      top: 55%;*/
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }
}
</style>
